/**
 * Find every candidate filing embed on the page and wire up
 * client-side filter.
 */
export function addCandidateFilingSearch() {
	const targets = document.querySelectorAll<HTMLElement>(
		".candidate-filing-table",
	);

	for (const target of targets) {
		const rows = target.querySelectorAll("table tbody tr");
		wireSearch(target, rows.length);
	}
}

/**
 * Attach the client-side filter: typing in the search box hides any row whose
 * text doesn't contain the query, and updates the result count.
 */
function wireSearch(target: HTMLElement, totalRows: number) {
	const searchInput = target.querySelector<HTMLInputElement>(
		"input[data-data-search]",
	);
	const status = target.querySelector<HTMLElement>("[data-data-status]");
	const tableRows = target.querySelectorAll<HTMLTableRowElement>("tbody tr");

	const updateStatus = (visible: number) => {
		if (!status) return;
		status.textContent =
			visible === totalRows
				? `${totalRows} filings`
				: `${visible} of ${totalRows} filings`;
	};

	updateStatus(totalRows);

	searchInput?.addEventListener("input", () => {
		const query = searchInput.value.trim().toLowerCase();
		let visible = 0;

		for (const row of tableRows) {
			const matches =
				query === "" || (row.textContent ?? "").toLowerCase().includes(query);
			row.hidden = !matches;
			if (matches) visible++;
		}

		updateStatus(visible);
	});
}
